import '.aw{height:100%;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.ee{min-height:0px;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { expandImage, StoredImage } from '@app/types/StoredImage'
import { Style, styled } from 'inlines'

export type ImagePreviewProps = {
  image: string | StoredImage
  altFallback?: string
  index: number
  wrapperStyle?: Style
  imageStyle?: Style
  onImageClick: (index: number) => void
}

export const ImagePreview = ({
  image,
  altFallback,
  index,
  wrapperStyle,
  imageStyle,
  onImageClick,
}: ImagePreviewProps) => {
  const { src, altText } = expandImage(
    image,
    altFallback ?? `Image ${index + 1}`,
  )
  return (
    <styled.div className="aw l ee"
      style={{ ...wrapperStyle }}
    >
      <Image
        onClick={() => onImageClick(index)}
        src={src}
        alt={altText}
        resizeWidth={1000}
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          display: 'block',
          ...imageStyle,
        }}
      />
    </styled.div>
  )
}
